<template>
  <div class="home">
    <!-- 顶部图标 -->
    <!-- <wd-navbar light>
      <div
        slot="left"
        style="
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        "
      >
        <img :src="logo" style="max-height: 45px" alt="" />
      </div>
      <div slot="right" class="toolBox">
        <!== <a
          :href="'tel:' + rolePhoneNum"
          style="height: 100%; display: flex; align-items: center; justify-content: flex-end"
          ><img src="../../assets/img/phone.png" style="max-height: 25px" alt=""
        /></a> ==>
        <img
          src="../../assets/img/GongGao.png"
          alt="GongGao"
          @click="openAnnouncem"
        />
        <img
          src="../../assets/img/phone.png"
          alt="phone"
          @click="isPhoneShow = true"
        />
      </div>
    </wd-navbar> -->

    <!-- 轮播图 -->
    <wd-swipe>
      <wd-swipe-item
        v-for="(item, index) in pics"
        :key="index"
        style="height: 180px"
      >
        <img :src="item.url" style="width: 100%; height: 100%" alt="" />
      </wd-swipe-item>
    </wd-swipe>

    <!-- 中间功能块 -->
    <div class="main-content">
      <div class="navbar">
        <div
          style="
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <img :src="logo" style="max-height: 45px" alt="" />
        </div>
        <div class="toolBox">
          <!-- <a
          :href="'tel:' + rolePhoneNum"
          style="height: 100%; display: flex; align-items: center; justify-content: flex-end"
          ><img src="../../assets/img/phone.png" style="max-height: 25px" alt=""
        /></a> -->
          <img
            src="~@/assets/img/icon-volumeSmall.png"
            @click="openAnnouncem"
          />
          <img
            src="~@/assets/img/icon-phoneCall.png"
            @click="isPhoneShow = true"
          />
        </div>
      </div>
      <div class="list-group">
        <div
          class="list-item"
          style="width: 50%"
          v-for="(item, index) in menuList"
          v-if="item.show"
          :key="index"
          @click="goto(item.url)"
        >
          <img class="img-icon" :src="item.pic" />
          <span class="title-text">
            {{ item.text }}
          </span>
        </div>
      </div>
    </div>

    <!-- tab切换 -->
    <wd-tabbar v-model="tabbar" fixed border>
      <!-- <wd-tabbar-item icon="wd-icon-bags" class="tabbarClass">
        <template #icon>
          <img class="img-icon" />
        </template>
        首页
      </wd-tabbar-item> -->

      <wd-tabbar-item class="tabbarClass">
        <template #icon>
          <img class="img-icon" src="~@/assets/img/icon-homeActive.png" />
        </template>
        首页
      </wd-tabbar-item>

      <wd-tabbar-item
        icon="wd-icon-setting"
        class="tabbarClass"
        to="/configure"
      >
        <template #icon>
          <img class="img-icon" src="~@/assets/img/icon-configDefult.png" />
        </template>
        设置
      </wd-tabbar-item>
    </wd-tabbar>

    <!-- 联系方式弹窗 -->
    <wd-popup
      v-model="isPhoneShow"
      position="bottom"
      :style="{ height: '200px' }"
      closable
      class="contPopup defaultPopup"
    >
      <p class="title">联系方式</p>
      <div class="content">
        <a
          v-for="item in rolePhoneList"
          :key="item"
          class="item"
          :href="'tel:' + item"
        >
          {{ item }}
        </a>
      </div>
    </wd-popup>
    <!-- 公告弹窗 -->
    <wd-popup
      v-model="isAnnouncemShow"
      class="announcemPopup defaultPopup"
      closable
    >
      <p class="title">公告</p>
      <div class="content">
        <div
          v-for="item in h5GongGaoList"
          :key="item.id"
          class="item"
          :href="'tel:' + item"
          @click="openAnnouncemAlert(item)"
        >
          <span>{{ item.lebal }}</span>
          <wd-icon name="arrow-right"></wd-icon>
        </div>
      </div>
    </wd-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: "",
      tabbar: 0,
      pics: [],
      imageObject: null,
      menuList: [
        {
          url: "/pay",
          text: "综合缴费",
          show: true,
          pic: require("@/assets/img/home-icon1.png"),
        },
        {
          url: "/selectEquip",
          text: "用量查询",
          show: true,
          pic: require("@/assets/img/home-icon1.png"),
        },
        {
          url: "/control",
          text: "实时控制",
          show: true,
          pic: require("@/assets/img/home-icon3.png"),
        },
        {
          url: "/config",
          text: "费用配置",
          show: true,
          pic: require("@/assets/img/home-icon4.png"),
        },
        {
          url: "/selectObject",
          text: "缴费记录",
          show: true,
          pic: require("@/assets/img/home-icon5.png"),
        },
        {
          url: "/power",
          text: "综合能耗",
          show: true,
          pic: require("@/assets/img/home-icon6.png"),
        },
      ],
      roleKey: null,
      hasRoleIamges: ["1", "2", "4"],
      rolePhoneNum: null,
      isPhoneShow: false,
      isAnnouncemShow: false,
      rolePhoneList: [],
      h5GongGaoList: [
        // {
        //   id: "1",
        //   lebal: "公告1",
        //   value:
        //     "这是一段公告，这是一段公告，这是一段公告，这是一段公告这是一段公告这是一段公告这是一段公告这是一段公告这是一段公告",
        // },
        // {
        //   id: "2",
        //   lebal: "公告2",
        //   value:
        //     "这是一段公告，这是一段公告，这是一段公告，这是一段公告这是一段公告这是一段公告这是一段公告这是一段公告这是一段公告",
        // },
      ],
    };
  },
  created() {
    this.rolePhoneNum = localStorage.getItem("rolePhoneNum");
    if (this.rolePhoneNum) {
      this.rolePhoneList = localStorage.getItem("rolePhoneNum").split(",");
    }

    // rolePhoneList
    let showControl = localStorage.getItem("showControl");
    if (showControl == "false") {
      this.menuList[1].show = false;
      this.menuList[2].show = false;
      this.menuList[3].show = false;
      this.menuList[5].show = false;
    }
    this.roleKey = localStorage.getItem("roleKey");
    this.imageObject = new Image();

    // 判断对应用户组是否有配置定制图片
    this.handlePics();

    // this.rolePhoneList
  },
  mounted() {
    // 判断对应用户组是否有配置定制图片
    if (this.hasRoleIamges.includes(`${this.roleKey}`)) {
      let urlc = this.roleKey + ".png?" + new Date().getTime();
      this.logo = "./static/img/role/logo/" + urlc;
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    handlePics() {
      this.pics = [];
      if (this.hasRoleIamges.includes(`${this.roleKey}`)) {
        let url = window.origin + window.location.pathname;
        // 轮播图
        for (let i = 1; i < 6; i++) {
          let src = url + "/static/img/role/" + this.roleKey + "/" + i + ".jpg";
          console.log("this.roleKey", this.roleKey);
          this.CheckImgExists(src).then((res) => {
            if (res) {
              let obj = {
                url: ``,
              };
              obj.url =
                "./static/img/role/" +
                this.roleKey +
                "/" +
                i +
                ".jpg?" +
                new Date().getTime();
              this.pics.push(obj);
            }
          });
        }
      } else {
        let obj = {
          url: require("../../assets/img/home-bg.png"),
        };
        this.pics.push(obj);
      }
    },
    CheckImgExists(imgurl) {
      return new Promise(function (resolve, reject) {
        let ImgObj = new Image(); //判断图片是否存在
        ImgObj.src = imgurl;
        ImgObj.onload = function (e) {
          if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
            resolve(true);
          } else {
            reject(false);
          }
        };
      });
    },
    openAnnouncemAlert(item) {
      // console.log(item);
      this.$messageBox.alert(item.value, item.lebal, {
        confirmButtonText: "已知",
      });
    },
    openAnnouncem() {
      this.$http
        .get("/external/notice/list", {
          params: {
            noticeScope: 2,
            status: 0,
            roleKey: this.roleKey,
          },
        })
        .then((res) => {
          this.h5GongGaoList = res.rows.map((item) => ({
            id: item.noticeId,
            lebal: item.noticeTitle,
            value: item.noticeContent,
          }));
        });
      this.isAnnouncemShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100vw;
  height: 100vh;
}
// 图标
.navbar {
  position: absolute;
  top: 0;
  right: 25px;
  display: flex;
  justify-content: space-between;
  height: 50px;
  z-index: 999;
  .toolBox {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // justify-content: space-between;
    & > img {
      height: 30px;
      margin-left: 10px;
    }
  }
}
// 中间图标框
// .main-content .listBtn {
//   border-bottom: 1px solid rgba(#eee, 0.7);
//   &:nth-child(n) {
//     border-right: 1px solid rgba(#eee, 0.7);
//   }
// }
.main-content {
  position: relative;
  min-height: 300px;
  border-radius: 20px 20px 0 0;
  background-color: white;
  margin-top: -55px;
  padding: 40px 30px;
  .list-group {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    // padding: 0px 0 10px 0;
    padding: 15px 0 30px 0;
    border-radius: 10px;
    box-shadow: 0 0 10px 0px rgba(173, 181, 189, 0.5);
    .list-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100px;
      &:nth-of-type(-n + 4) {
        margin-bottom: 10px;
      }
      .img-icon {
        width: 70px;
        height: 70px;
      }
      .title-text {
        margin-top: 3px;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
}

// 底部tabbar
.wd-tabbar {
  border-radius: 10px 10px 0 0;
  box-shadow: 0 0 5px 0px rgba(173, 181, 189, 0.5);
  &::after {
    height: 0;
  }
}
.tabbarClass {
  ::v-deep .wd-tabbar-item__label {
    font-size: 14px;
    font-family: 微软雅黑;
    margin-top: -3px;
    font-weight: bold;
    color: #ced4da;
  }
}
.tabbarClass.is-active {
  ::v-deep .wd-tabbar-item__label {
    font-weight: bold;
    color: #4d80f0;
  }
}
// 弹出框
.defaultPopup {
  box-sizing: border-box;
  padding: 11px 15px 0px 15px !important;
  .title {
    margin: 0;
    color: #000;
    font-size: 18px;
    text-align: center;
    margin-bottom: 15px;
  }
  .item {
    display: block;
    margin-bottom: 10px;
    color: white;
    background-color: #5581f8;
    height: 30px;
    line-height: 30px;
    border: 1px solid #5681f8;
    box-shadow: 0px 0px 3px #5681f8;
    border-radius: 5px;
  }
}
// 联系方式弹窗
.contPopup {
  .content {
    a {
      text-align: center;
      text-decoration: none;
    }
  }
}

// 公告弹窗
.announcemPopup {
  width: 300px;
  height: 450px;
  border-radius: 10px;

  .content .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > span {
      font-weight: bold;
      margin-left: 5px;
    }
    & > i {
      margin-right: 5px;
    }
  }
  .content .item:hover {
    background-color: #4d78ed;
  }
}
</style>
